<template>
    <div>
        <NavbarStyleTwo />
        <Faq />
        <FreeTrial />
        <Footer :showDivider="true" />
    </div>
</template>

<script>
import NavbarStyleTwo from '../Layouts/NavbarStyleTwo';
import PageTitle from '../Common/PageTitle';
import Faq from '../Common/Faq';
import BestSupport from '../Common/BestSupport';
import FreeTrial from '../Common/FreeTrial';
import Footer from '../Layouts/Footer';

export default {
    components: {
        NavbarStyleTwo,
        PageTitle,
        Faq,
        BestSupport,
        FreeTrial,
        Footer,
    }
};
</script>